import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import { ItemToReturn } from "../../../domain/entities/order/Order";
import {
  OrderRepositoryImpl,
  ReturnOrderItemsPayloadWithAuth,
} from "../../domain/orderRepositoryImpl/OrderRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const orderRepo = OrderRepositoryImpl.getInstance();

interface RequestReturnItemsProps {
  readonly orderId: string;
  readonly serviceId: string;
  readonly items: ItemToReturn[];
  readonly onSuccess: () => void;
  readonly onError?: (error: unknown) => void;
}

const useRequestReturnOrderItems = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const mutation = useMutation(
    {
      mutationFn: async (payload: ReturnOrderItemsPayloadWithAuth) => {
        return orderRepo.requestReturnOrderItems(payload);
      },
    },
    queryClient,
  );

  const requestReturnItems = useCallback(
    ({ orderId, serviceId, items, onSuccess, onError }: RequestReturnItemsProps) => {
      const payload = {
        auth,
        orderId,
        serviceId,
        items,
        apiUrl,
      };
      mutation.mutate(payload, { onSuccess, onError });
    },
    [apiUrl, auth, mutation],
  );

  return requestReturnItems;
};

export { useRequestReturnOrderItems };
